<path id="path-{id}" {...data} />

<script>export let id;
export let data = {};
</script>
